// Checkout link — only the purchase button inside the offer section uses it.
export const checkoutUrl = 'https://ministry-ready-hub.impultienda.ar/checkout';

// Contact & social links for the footer. Leave '' to hide.
export const contact = {
  email: '',
  instagram: '',
  facebook: '',
  privacyUrl: '',
  termsUrl: '',
};

export const product = {
  brand: 'Ministry Ready Hub',
  name: 'Youth Ministry Ready™',
  series: 'Identity & Faith',
  volume: 'Volume 01',
  price: '27',
  currency: 'USD',
  ctaLabel: 'Get Youth Ministry Ready™',
  mockup: 'https://cdn.magicpatterns.com/uploads/7s9SrcrkpmuyBCiCLDUN43/Caja_premium_de_ministerio_juvenil.png',
  cover: 'https://cdn.magicpatterns.com/uploads/bjkcNHfbrzpzakb7ewuBr4/01_portada.png',
  handout: 'https://cdn.magicpatterns.com/uploads/cVGGYZp9fEmpuknCRGpqFw/05_hoja_alumno.png',
};

export const heroTicks = ['12 Meetings', '5 Bonuses', 'Leader Scripts', 'Printable Handouts', 'Ages 12–18'];

export const trustStats = [
  { value: '12 + 5', label: 'Meetings & bonuses' },
  { value: '60/45', label: 'Minute agendas' },
  { value: '12–18', label: 'Student ages' },
  { value: 'Worldwide', label: 'Digital access anywhere' },
];

export const problems = [
  {
    icon: 'file' as const,
    title: 'The blank document',
    body: 'A full day of work, then an evening piecing together Friday’s meeting from scratch.',
  },
  {
    icon: 'game' as const,
    title: '“What do we play?”',
    body: 'You need a game that’s affordable, clear, and works for whoever actually shows up.',
  },
  {
    icon: 'book' as const,
    title: '“How do I explain this?”',
    body: 'Finding the passage is the easy part. Turning it into a talk with a real application isn’t.',
  },
  {
    icon: 'chat' as const,
    title: 'The silent circle',
    body: 'You ask a question and nobody answers. You need the next question ready—and a clear way to close.',
  },
];

export const solutionSteps = [
  { title: 'Choose your meeting', body: 'Check the agenda, Bible passage, and supplies.' },
  { title: 'Print & prepare', body: 'Read the leader script, gather materials, print the handouts.' },
  { title: 'Lead with a plan', body: 'Follow the speaking cues and use the questions to guide your group.' },
];

export const meetingComponents = [
  { icon: 'clock' as const, title: 'Timed agenda', body: 'A 60-minute session, with a 45-minute option.' },
  { icon: 'game' as const, title: 'Icebreakers & main games', body: 'Supplies, setup, and numbered rules.' },
  { icon: 'book' as const, title: 'Leader script', body: 'Ready to read, with Bible context and practical application.' },
  { icon: 'chat' as const, title: '7 discussion questions', body: 'With follow-up prompts and age adaptations.' },
  { icon: 'flag' as const, title: 'Challenge & closing prayer', body: 'End every meeting with a clear next step.' },
  { icon: 'print' as const, title: 'Student handout', body: 'A separate page, ready to print and send home.' },
];

export const meetings = [
  'More Than a Label',
  'Made with Purpose',
  'Belonging Before Performing',
  'Questions Are Welcome',
  'Prayer Without Perfect Words',
  'Trust When You Cannot See the Whole Picture',
  'Reading the Bible with Context',
  'Small Choices, Real Integrity',
  'Grace After a Mistake',
  'Faith Beyond Youth Night',
  'Gratitude in Ordinary Days',
  'A Next Step That Is Actually Yours',
];

export const samplePages: { label: string; image: string }[] = [
  { label: 'Volume 01 — Cover', image: 'https://cdn.magicpatterns.com/uploads/bjkcNHfbrzpzakb7ewuBr4/01_portada.png' },
  { label: 'Contents — All 12 meetings', image: 'https://cdn.magicpatterns.com/uploads/gPu1ErDNgvgrM3J1wD7QWF/02_indice_12_encuentros.png' },
  { label: 'First-Time Leader field guide', image: 'https://cdn.magicpatterns.com/uploads/k8dgWzhfBkbSGcfJRG4pD5/03_guia_lider.png' },
  { label: 'YMR-01 — Icebreaker & main game', image: 'https://cdn.magicpatterns.com/uploads/a4EN7Ar815J1mB64J2PwcW/04_rompehielo_juego.png' },
  { label: 'YMR-02 — Student handout', image: 'https://cdn.magicpatterns.com/uploads/cVGGYZp9fEmpuknCRGpqFw/05_hoja_alumno.png' },
];

export const bonuses = [
  {
    shortTitle: 'Your Next 12 Weeks',
    subtitle: 'Youth Ministry Calendar',
    image: 'https://cdn.magicpatterns.com/uploads/xweyEEfm39G1yvSBLJiCki/ministerio_1.webp',
    body: 'A suggested schedule for all 12 meetings, with preparation reminders and weekly challenges. See the next three months at a glance.',
  },
  {
    shortTitle: 'First-Time Leader',
    subtitle: 'Quick-Start Kit',
    image: 'https://cdn.magicpatterns.com/uploads/1hdB1rSPVP4XYceLSyAn9m/ministerio_2.webp',
    body: 'Opening scripts, preparation checklists, game introduction examples, and practical ways to handle silence and welcome newcomers.',
  },
  {
    shortTitle: 'Plan B Ready',
    subtitle: '10 Low-Prep Youth Meetings',
    image: 'https://cdn.magicpatterns.com/uploads/pGJvzjqCqrmZNQj1bBgMUX/ministerio_3.webp',
    body: 'Ten extra plans for last-minute changes: simple activities, short Bible scripts, questions, and challenges. No special equipment or internet.',
  },
  {
    shortTitle: 'Parent Connect',
    subtitle: 'Communication Kit',
    image: 'https://cdn.magicpatterns.com/uploads/p2Q1sAGuJ9uTwT2BG12QGD/ministerio_4.webp',
    body: '15 ready-to-edit email and text templates for welcomes, reminders, schedule changes, invitations, and follow-ups.',
  },
  {
    shortTitle: 'Youth Game Night Ready',
    subtitle: 'Complete Event Kit',
    image: 'https://cdn.magicpatterns.com/uploads/2jP4JezbsEmXKPWAfmPFyt/ministerio_5.webp',
    body: 'A two-hour event plan with explained games, supply lists, volunteer role cards, an invitation template, and a short Bible-based closing.',
  },
];

export const offerIncluded = [
  '12 complete meeting plans',
  'Ready-to-read leader scripts',
  'Games with supplies & rules',
  '7 discussion questions each',
  'Printable student handouts',
  '60-min agendas + 45-min option',
];

export const guaranteeText =
  "If the resource isn't a fit, request a refund within 10 days of purchase through your order contact channel and we'll give your money back. No questions asked.";

export const faqs = [
  {
    question: 'What exactly do I get?',
    answer:
      'Volume 01 of Youth Ministry Ready™ (Identity & Faith): 12 complete Bible-based meetings, each with a timed agenda, games, a leader script, discussion questions, a weekly challenge, a closing prayer, and a student handout. Plus all 5 bonus resources.',
  },
  {
    question: 'Does this plan my entire year?',
    answer:
      'No. This volume provides 12 core meetings plus five bonuses. The Plan B bonus adds 10 separate low-prep meetings. The full 52-week collection is separate.',
  },
  {
    question: "What if I've never led a youth group?",
    answer:
      "The leader scripts, numbered activity instructions, and Quick-Start Kit are designed to support first-time volunteers. Review the meeting ahead of time and follow your church's training and safeguarding procedures.",
  },
  {
    question: 'What ages and group sizes is it for?',
    answer:
      'Teenagers ages 12–18. The core format is designed for 8–20 participants, with adaptations for smaller and larger groups, plus seated or low-movement alternatives.',
  },
  {
    question: 'Is this tied to a specific denomination?',
    answer:
      'The content uses broadly accessible Christian teaching and avoids making disputed denominational practices central. Review Bible interpretations and adapt the material to your church context.',
  },
  {
    question: 'How long does each meeting last?',
    answer: 'Each meeting includes a 60-minute agenda and guidance for a 45-minute version.',
  },
  {
    question: 'Is this a printed book?',
    answer:
      'No. It’s an English-language digital PDF resource, available worldwide. Read the leader pages on a device and print the student handouts. Nothing is shipped.',
  },
  {
    question: 'Do I need special equipment?',
    answer:
      "Activities prioritize ordinary low-cost supplies. Check each meeting's materials list before leading. The Plan B bonus needs no special equipment or internet.",
  },
  {
    question: 'Is it a subscription?',
    answer: 'No. It’s a one-time payment of $27 USD.',
  },
  {
    question: 'How does the guarantee work?',
    answer: `You have a 10-day money-back guarantee. ${guaranteeText}`,
  },
];

export const closingWithout = [
  'Another evening searching for a game',
  'A blank document after a full day of work',
  'A Bible talk pieced together at the last minute',
  'Hoping the discussion doesn’t stall',
];

export const closingWith = [
  'A timed agenda for every meeting',
  'Games with supplies, setup, and rules',
  'A ready-to-read leader script',
  'Questions with follow-up prompts',
];
